export default __webpack_public_path__ + "static/media/Test_image.26b349f5.png";